import { connect } from 'react-redux';

import { locationSelector } from '../reducers';
import {
  isAuthenticatedSelector,
  isAdministratorSelector,
} from '../reducers/auth';

import AdministrativeNavigationComponent from '../components/AdministrativeNavigation';

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticatedSelector(state),
    isAdministrator: isAdministratorSelector(state),
    location: locationSelector(state),
  };
};

const AdministrativeNavigation = connect(mapStateToProps)(AdministrativeNavigationComponent);

export default AdministrativeNavigation;
